export enum ClickAdEventTarget {
  CloseButton = 'close_button',
  CloseClickOutsidePlacement = 'close_click_outside_placement',
  Creative = 'creative',
  Cta = 'cta',
  AdInfo = 'ad_info',
  SecondaryButton = 'secondary_button',
  PrivacyPolicy = 'privacy_policy',
}
